import axios from 'axios';
export const submitLead = async (root, input) => axios.post(`${root}/pages/lead`, input);
//# sourceMappingURL=lead.js.map